export interface WordResult {
  reading: string;
  definition: string;
}

interface Props {
  word: string;
  reading: string;
  rect: DOMRect;
  result: WordResult | null;
  fetching: boolean;
  onClose: () => void;
}

export default function WordPopup({ word, reading, rect, result, fetching, onClose }: Props) {
  const top = rect.bottom + 8;
  const left = Math.min(rect.left, window.innerWidth - 240);

  return (
    <>
      <div className="fixed inset-0 z-10" onClick={onClose} />
      <div
        className="fixed z-20 bg-zinc-900 border border-zinc-700 rounded-lg p-4 w-56 shadow-2xl"
        style={{ top, left }}
      >
        <p className="text-white font-medium text-lg">{word}</p>
        <p className="text-zinc-500 text-sm mb-2">{reading}</p>
        {fetching ? (
          <div className="w-4 h-4 border-2 border-t-zinc-400 border-zinc-700 rounded-full animate-spin" />
        ) : result ? (
          <p className="text-zinc-300 text-sm">{result.definition}</p>
        ) : (
          <p className="text-zinc-600 text-sm">no results</p>
        )}
      </div>
    </>
  );
}
